const defaultState={
    data:null
}
const DataReducer =async (state=defaultState,action)=>{

    switch(action.type){
        case "DATA": 
            return {...state,data:action.payload.data}
        case "FAIL":
            return {...state,data:null}
        default:
            return state;
    }

}
export default DataReducer;